import { STORE_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import store from "@/store";
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  CHAT_BOT_CONSTANTS,
  CHAT_TOOLTIP,
  IMG_SOURCE,
  WINDOW_SIZES
} from "./constants/ChatBotConstants";
import { CHAT_ACTIONS } from "@/modules/Home/components/ChatWindow/Constants/ChatWindow.constants";
import { mapGetters } from "vuex";
import { ChatComunication } from "@/modules/Home/components/ChatWindow/Model/ChatComunication.model";

@Component({
  name: "ChatBot",
  computed: {
    ...mapGetters({
      chatAction: "getChatComunication"
    })
  }
})
export default class ChatBot extends Vue {
  btnClassTertiary = STYLE_CLASSES.TERTIARY_BTN;
  runtimeTranscription = "";
  globalMic = true;
  showMic = false;
  toggle = false;
  error = "";
  text = "";
  ACTIONS = CHAT_ACTIONS;
  IMG_SOURCE = IMG_SOURCE;
  CHAT_TOOLTIP = CHAT_TOOLTIP;
  chatAction!: ChatComunication;

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  SpeechRecognition =
    (window as any).SpeechRecognition ||
    (window as any).webkitSpeechRecognition;
  recognition: SpeechRecognition = this.SpeechRecognition
    ? new this.SpeechRecognition()
    : false;
  WINDOW_SIZES_CONST = WINDOW_SIZES;
  windowWidth = this.WINDOW_SIZES_CONST.DEFAULT_SIZE;

  mounted() {
    this.checkCompatibility();
    this.reziseCards();
    window.addEventListener("resize", this.reziseCards);
    this.showMic = this.chatAction.chatOpen ?? false;
  }
  checkCompatibility() {
    if (!this.recognition) {
      this.error = CHAT_BOT_CONSTANTS.COMPATIBILITY_ERROR;
      this.globalMic = false;
    }
  }

  endSpeechRecognition() {
    this.sendToMainView(this.ACTIONS.STOP_SPEECH_RECORD);
    this.toggle = false;
  }

  startSpeechRecognition() {
    this.sendToMainView(this.ACTIONS.START_SPEECH_RECORD);
    this.toggle = true;
  }

  capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  reziseCards() {
    this.windowWidth =
      window.screen.availWidth ?? this.WINDOW_SIZES_CONST.DEFAULT_SIZE;
  }
  unmounted() {
    window.removeEventListener("resize", this.reziseCards);
  }

  openChat() {
    this.showMic = true;
    this.sendToMainView(this.ACTIONS.OPEN_CHAT);
  }
  sendToMainView(action: string) {
    const chatAction: ChatComunication = {
      action: action
    };
    store.commit(STORE_CONSTANTS.CHAT_ACTION, chatAction);
  }

  @Watch("chatAction")
  handleChatAction() {
    if (
      this.chatAction.action != "" &&
      this.chatAction.action == this.ACTIONS.CLOSE_CHAT
    ) {
      this.showMic = false;
      this.toggle = false;
      store.commit(STORE_CONSTANTS.CHAT_ACTION, { action: "" });
      return;
    }
  }
}
